import { render, staticRenderFns } from "./lifeList.vue?vue&type=template&id=273976d5&"
import script from "./lifeList.vue?vue&type=script&lang=js&"
export * from "./lifeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports